/**
 * Centralized constants for the Needs Analysis Survey
 */

import type {
  CommunicationChannelPreference,
  CommunicationFrequencyPreference,
  IndustryInterest,
  PrimaryGoal,
  TestType,
} from '@/types/learner-portal'
import {
  COMMUNICATION_CHANNEL_LABELS,
  COMMUNICATION_FREQUENCY_LABELS,
  INDUSTRY_LABELS,
  PRIMARY_GOAL_LABELS,
  TEST_TYPE_LABELS,
} from '@/types/learner-portal'

export {
  NATIVE_LANGUAGES,
  NATIVE_LANGUAGE_LABELS,
  LANGUAGE_TO_LOCALE,
} from '@/constants/nativeLanguages'

// Industry interests (derived from labels)
export const INDUSTRIES: IndustryInterest[] = Object.keys(INDUSTRY_LABELS) as IndustryInterest[]

// Primary goals (derived from labels)
export const PRIMARY_GOALS: PrimaryGoal[] = Object.keys(PRIMARY_GOAL_LABELS) as PrimaryGoal[]

// Test types (derived from labels)
export const TEST_TYPES: TestType[] = Object.keys(TEST_TYPE_LABELS) as TestType[]

// Communication channels (derived from labels)
export const COMMUNICATION_CHANNELS: CommunicationChannelPreference[] = Object.keys(
  COMMUNICATION_CHANNEL_LABELS
) as CommunicationChannelPreference[]

// Communication frequencies (derived from labels)
export const COMMUNICATION_FREQUENCIES: CommunicationFrequencyPreference[] = Object.keys(
  COMMUNICATION_FREQUENCY_LABELS
) as CommunicationFrequencyPreference[]

// Pre-selected answers for the communication questions
export const DEFAULT_COMMUNICATION_CHANNELS: readonly CommunicationChannelPreference[] = COMMUNICATION_CHANNELS.filter(
  (channel) => channel !== 'other'
)
export const DEFAULT_COMMUNICATION_FREQUENCY: CommunicationFrequencyPreference = 'daily'

// Screen types for the survey flow
export enum SurveyScreen {
  INTRO = 'intro',
  LANGUAGE = 'language',
  ENGLISH = 'english',
  TIME = 'time',
  GOALS = 'goals',
  INDUSTRIES = 'industries',
  TEST_TYPE = 'testType',
  COMMUNICATION_CHANNELS = 'communicationChannels',
  COMMUNICATION_FREQUENCY = 'communicationFrequency',
  DONE = 'done',
}
